// extracted by mini-css-extract-plugin
module.exports = {"ovenLights":"styles_ovenLights__ETUmO","lightGroup":"styles_lightGroup__3416S","image":"styles_image__28Wa-","disabled":"styles_disabled__158vJ","text":"styles_text__2Bik_"};